import { UserCoreRole } from '@app/types';
import { useServices } from './use-services';
import { useSubject } from './useSubject';

export type UseDesignRolesResult = {
  designRoles: Set<UserCoreRole>;
  hasDesignRole: (role: UserCoreRole | UserCoreRole[], every?: boolean) => boolean;
};

export function useDesignRoles(): UseDesignRolesResult {
  const { userService } = useServices();
  const designRoles = useSubject(
    userService.designRoles,
    userService.designRoles.value
  );

  return {
    designRoles,
    hasDesignRole: (roles, every) => userService.hasDesignRole(designRoles, roles, every)
  };
}
